module.exports = __webpack_public_path__ + "img/quote-GW@ico.03e2af47.png";